﻿export namespace EmailQueuePermissionKeys {
    export const EmailQueue = "Administration:EmailQueue";
}